import React from "react";
import StuckFile from "../StuckFile";

const StuckFileJewelry = () => {
  return <StuckFile type="Jewelry" />;
};

export default StuckFileJewelry;
